interface JwtPayload {
  aud: string;
  authority: string;
  companyId: string;
  exp: number;
  iss: string;
  loginType: string;
  scope: Record<string, string>;
  userId: string;
}

const isObject = (value: unknown): value is Record<string, unknown> => {
  return typeof value === "object" && value !== null;
};
/**
 * 利用するパラメータが存在するかどうかを確認する
 */
const validateJwtPayload = (payload: unknown): JwtPayload => {
  if (isObject(payload) === false) {
    throw new Error("JWT payload is not an object");
  }

  if (typeof payload?.exp !== "number" || typeof payload?.userId !== "string") {
    throw new Error("JWT payload is missing required fields");
  }

  return payload as unknown as JwtPayload;
};

export const parseJwtPayload = (jwt: string): JwtPayload | null => {
  try {
    const splitted = jwt.split(".");
    if (splitted.length !== 3) {
      throw new Error("Invalid JWT");
    }
    const [, payload] = splitted;
    return validateJwtPayload(JSON.parse(atob(payload)));
  } catch (error: unknown) {
    console.error(error);
    return null;
  }
};

export const checkJwtExpiration = (jwt: string): boolean => {
  const payload = parseJwtPayload(jwt);
  if (!payload) {
    return false;
  }
  return new Date() < new Date(payload.exp * 1000);
};
